import { Service } from '@angular/core';
import { MadCloudCommit } from '@common/git/models/mad-cloud-commit.model';
import { CommitsState } from '@portal-core/commits/services/commits-data.service';
import { PageDataServiceBase, PageState, PageStateBase, PageStateService } from '@portal-core/data/page/services/page.state';

@PageState({
  name: 'projectCommitsPageState',
  actionName: 'ProjectCommitsPage'
})
export class ProjectCommitsPageState extends PageStateBase { }

@Service()
@PageStateService<MadCloudCommit>({
  pageState: ProjectCommitsPageState,
  itemCollectionState: CommitsState
})
export class ProjectCommitsPageDataService extends PageDataServiceBase<MadCloudCommit> {
  override state = ProjectCommitsPageState;
}
